import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';

const ToastNotification = ({ notifications, onDismiss }) => {
  return (
    <div className="fixed top-4 right-4 z-1000 space-y-2 max-w-sm w-full">
      {notifications?.map(notif => (
        <div
          key={notif?.id}
          className={`flex items-start space-x-3 p-3 rounded-xl shadow-xl border animate-fade-in ${
            notif?.type === 'urgent' ?'bg-error text-white border-error'
              : notif?.type === 'success' ?'bg-success text-white border-success' :'bg-primary text-white border-primary'
          }`}
        >
          <Icon
            name={notif?.type === 'urgent' ? 'AlertTriangle' : notif?.type === 'success' ? 'CheckCircle' : 'Bell'}
            size={16}
            color="white"
            className="flex-shrink-0 mt-0.5"
          />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold">{notif?.title}</p>
            <p className="text-xs opacity-80 mt-0.5">{notif?.message}</p>
          </div>
          <button
            onClick={() => onDismiss?.(notif?.id)}
            className="flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity"
          >
            <Icon name="X" size={14} color="white" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastNotification;
